export default __webpack_public_path__ + "static/media/calc.5bddac75.svg";